<template>
  <div class="page-wrap">
    <div class="header-filter">
      <div class="filter-title">
        <span class="title-text">素材制作信息</span>
        <div>
          <el-button v-if="isAdmin" class="btn" @click="handlerCustomGroup">自定义制作小组 </el-button>
          <el-button v-if="isAdmin" class="btn" @click="handlerCustomSize">自定义素材尺寸 </el-button>
          <el-button type="primary" @click="editData()">新增需求</el-button>
        </div>
      </div>
      <div class="select-wrap">
        <el-select class="select-item" v-model="filterData.afid" placeholder="玩法" filterable @change="searchData(true)">
          <el-option label="全部玩法" :value="-1"> </el-option>
          <el-option v-for="item in productList" :key="item.id" :label="item.playName" :value="item.afid">
            <span style="float: left">{{ item.playName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.afid }}</span>
          </el-option>
        </el-select>
        <el-select class="select-item" v-model="filterData.materialDesigner" placeholder="设计人员" filterable @change="searchData(true)">
          <el-option label="全部设计人员" :value="-1"> </el-option>
          <el-option v-for="item of designerList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-select class="select-item" v-model="filterData.materialProductor" placeholder="制作人员" filterable @change="searchData(true)">
          <el-option label="全部制作人员" :value="-1"> </el-option>
          <el-option v-for="item of productorList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-select class="select-item" v-model="filterData.demandStatus" placeholder="需求状态" filterable @change="searchData(true)">
          <el-option label="全部需求状态" :value="-1"> </el-option>
          <el-option label="已完成" :value="1"> </el-option>
          <el-option label="进行中" :value="0"> </el-option>
        </el-select>
        <el-select class="select-item" v-model="filterData.creativeSource" placeholder="创意来源" filterable @change="searchData(true)">
          <el-option label="全部创意来源" :value="-1"> </el-option>
          <el-option label="竞品素材" value="竞品素材"> </el-option>
          <el-option label="投放设计" value="投放设计"> </el-option>
          <el-option label="视频自制" value="视频自制"> </el-option>
          <el-option label="策划" value="策划"> </el-option>
        </el-select>
        <!-- <el-select
          class="select-item"
          v-model="filterData.materialEffect"
          placeholder="素材综合效果"
          @change="searchData(true)"
        >
          <el-option label="全部素材综合效果" :value="-1"> </el-option>
          <el-option label="有效" :value="2"> </el-option>
          <el-option label="带量" :value="3"> </el-option>
        </el-select> -->
        <el-date-picker
          class="data-range"
          v-model="filterData.time"
          type="daterange"
          range-separator="→"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :clearable="false"
          @change="searchData(true)"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="table-header">
      <div class="header-item" v-for="item in headerList" :style="{ width: item.width }" :key="item.value">
        {{ item.label }}
      </div>
    </div>
    <div class="card-list">
      <material-card
        v-for="item of dataList"
        :key="item.id"
        :dataSet="item"
        @editData="editData"
        @copyFormData="copyFormData"
        @checkData="checkData"
        @changeTime="changeTime"
      ></material-card>
    </div>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>

    <!-- 新增和编辑弹框 -->
    <edit-modal ref="editModalRef" :productList="productList" :productorList="productorList" @refresh="searchData"></edit-modal>
    <!-- 时间修改框 -->
    <time-modal @refresh="searchData" ref="timeModalRef"></time-modal>
    <!-- 验收弹框 -->
    <check-modal @refresh="searchData" ref="checkModalRef"></check-modal>
    <!-- 自定义小组弹框 -->
    <custom-group-modal ref="customGroupModal"></custom-group-modal>
    <!-- 自定义素材尺寸弹框 -->
    <custom-size-modal ref="customSizeModal"></custom-size-modal>
  </div>
</template>

<script>
import moment from "moment";
import MaterialCard from "./materialCard.vue";
import EditModal from "./modals/editModal.vue";
import TimeModal from "./modals/timeModal.vue";
import CheckModal from "./modals/checkModal.vue";
import CustomGroupModal from "./modals/customGroupModal.vue";
import CustomSizeModal from "./modals/customSizeModal.vue";
import { getDesigner, getProductor, queryMaterial } from "@/api/materialManage.js";
import { headerList } from "../confData";
import { getPlayInfoList } from "@/api/rolepower.js";

export default {
  name: "MaterialCreate",
  components: {
    MaterialCard,
    EditModal,
    TimeModal,
    CheckModal,
    CustomSizeModal,
    CustomGroupModal,
  },
  mounted() {
    this.initSelect();
    this.searchData(true);
  },
  computed: {
    isAdmin() {
      const roles = JSON.parse(localStorage.getItem("userInfo")).roles || [];
      return roles.includes("biAdmin");
    },
  },
  data() {
    return {
      dataList: [],
      filterData: {
        afid: -1,
        materialDesigner: -1,
        materialProductor: -1,
        demandStatus: -1,
        creativeSource: -1,
        materialEffect: -1,
        time: [
          moment()
            .subtract(6, "days")
            .format("YYYY-MM-DD"),
          moment()
            .subtract(0, "days")
            .format("YYYY-MM-DD"),
        ],
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      productList: [],
      designerList: [],
      productorList: [],
      headerList,
    };
  },
  methods: {
    initSelect() {
      //设计人员
      getDesigner().then((res) => {
        this.designerList = res.designer;
      });
      //制作人员
      getProductor().then((res) => {
        if (res.code === "0000") {
          this.productorList = res.productor;
        }
      });
      // 玩法
      getPlayInfoList().then((res) => {
        this.productList = res.data.list;
      });
    },
    searchData(resetpage) {
      if (resetpage) {
        this.pageData.page = 1;
        this.pageData.size = 10;
      }
      console.log(this.pageData);
      let parmas = {
        page: this.pageData.page + "",
        size: this.pageData.size + "",
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let [key, value] of Object.entries(this.filterData)) {
        if (key !== "time" && value !== -1) {
          parmas[key] = value;
        }
      }
      queryMaterial(parmas).then((res) => {
        if (res.code === "0000") {
          this.dataList = res.materialInfos;
          this.pageData.total = res.count;
        }
      });
    },
    //修改
    editData(data) {
      this.$refs.editModalRef.editData(data);
    },
    // 复用
    copyFormData(data) {
      this.$refs.editModalRef.editData(data, "copy");
    },
    //验收
    checkData(data) {
      this.$refs.checkModalRef.showModal(data);
    },
    changeTime(data) {
      this.$refs.timeModalRef.editData(data);
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData(false);
    },
    handleSizeChange(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData(false);
    },
    //自定义制作小组
    handlerCustomGroup() {
      this.$refs.customGroupModal.showModal();
    },
    //自定义素材尺寸
    handlerCustomSize() {
      this.$refs.customSizeModal.showModal();
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: hidden;
  .header-filter {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px 0px 24px;
    position: -webkit-sticky;
    position: sticky;
    top: -16px;
    z-index: 1;
    .filter-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-text {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 15px;
      }
    }
    .btn {
      border: 1px solid rgba(24, 144, 255, 1);
      color: rgba(24, 144, 255, 1);
    }
    .select-wrap {
      margin-top: 16px;
      .select-item {
        width: 200px;
        margin: 0px 24px 16px 0px;
      }
      .data-range {
        position: relative;
        margin-bottom: 16px;
        /deep/.el-range__icon {
          position: absolute;
          right: 6px;
          top: 0px;
        }
        /deep/.el-range-separator {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
  }
  .table-header {
    height: 54px;
    border-radius: 4px;
    border: 1px solid rgba(234, 234, 234, 1);
    background: rgba(250, 250, 250, 1);
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    margin-top: 16px;
    margin-bottom: 8px;
    display: flex;
    .header-item {
      height: 14px;
      margin-top: 20px;
      border-left: 1px solid rgb(216, 215, 215);
      text-align: left;
      padding-left: 12px;
    }
    .header-item:first-child {
      border-left: none;
    }
  }
  .card-list {
    height: calc(100vh - 320px);
    overflow-y: overlay;
  }
  .footer-page {
    padding: 16px 0px;
  }
}
</style>
